<template>
    <div v-if="mode == 'save'">
        <button type="button" v-if="allowPress" v-on:click="$emit('button-clicked')" class="medium-button blue-gradient">
            <b-icon v-if="savingWatcher == false" icon="cloud-upload" class="mr-1" />
            <b-icon v-else icon="cloud-upload" :animation="animation" class="mr-1" />
            {{ $t('general.save') }}
        </button>
        <button type="button" v-else class="medium-button disabled">
            <b-icon v-if="savingWatcher == false" icon="cloud-upload" class="mr-1" />
            <b-icon v-else icon="cloud-upload" :animation="animation" class="mr-1" />
            {{ $t('general.save') }}
        </button>
    </div>
    <div v-else-if="mode == 'custom'">
        <button type="button" v-if="allowPress" v-on:click="$emit('button-clicked')" class="medium-button blue-gradient">
            <b-icon v-if="savingWatcher == true" :icon="busyIcon" :animation="animation" class="mr-1" />
            <b-icon v-else-if="staticIcon.length > 0" :icon="staticIcon" class="mr-1" />
            {{text}}
        </button>
        <button type="button" v-else class="medium-button disabled">
            <b-icon v-if="savingWatcher == true" :icon="busyIcon" :animation="animation" class="mr-1" />
            <b-icon v-else-if="staticIcon.length > 0" :icon="staticIcon" class="mr-1" />
            {{text}}
        </button>
    </div>
    <div v-else-if="mode == 'back'">
        <button type="button" v-if="allowPress" v-on:click="$emit('button-clicked')" class="medium-button blue-gradient d-inline-block icon-button">
            <b-icon-arrow-left class="mr-1" />
            <span class="d-md-inline-block d-sm-none d-none"> {{ $t('general.back') }} </span>
        </button>
        <button type="button" v-else class="medium-button disabled d-inline-block icon-button">
            <b-icon-arrow-left class="mr-1" />
            <span class="d-md-inline-block d-sm-none d-none"> {{ $t('general.back') }}</span>
        </button>
    </div>
    <div v-else-if="mode == 'next'">
        <button type="button" v-if="allowPress" v-on:click="$emit('button-clicked')" class="medium-button blue-gradient d-inline-block icon-button">
            <span class="d-md-inline-block d-sm-none d-none"> {{ $t('general.next') }}</span> <b-icon-arrow-right />
        </button>
        <button type="button" v-else class="medium-button disabled d-inline-block icon-button">
            <span class="d-md-inline-block d-sm-none d-none"> {{ $t('general.next') }}</span> <b-icon-arrow-right />
        </button>
    </div>

</template>

<script>

    export default {
        name: 'NavigationButton',
        components: {
        },
        props: {
            allowPress: Boolean,
            mode: String,
            text: String,
            busyIcon: String,
			staticIcon: {
				type: String,
				default: ''
			},
            animation: {
                type: String,
                default: 'throb'
            },
            useCustomSavingWatcher: {
                type: Boolean,
				default: false
            },
			customSavingWatcher: {
				type: Boolean,
				default: false
			},
        },
        mounted: function () {

        },
        data: function () {

            return {

            }

        },
        methods: {

        },
        computed: {
            savingWatcher: function () {
                if (this.useCustomSavingWatcher == true) {
                    return this.customSavingWatcher
                } else {
                    return this.$store.state.savingData
                }
            }
        },
        updated: function(){

        }
    }
</script>
